// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"Delimiter_delimiter__3DSFO"};